<router-outlet></router-outlet>
<app-media-lightbox></app-media-lightbox>